import { cn } from '@restworld/utils-common';
export type ModalTitleProps = {
  children: React.ReactNode | string;
};
// Login page titles: 24px semibold, centred, same size at every breakpoint (Figma 46:275).
export const authPageTitleClassName = 'w-full text-2xl lg:text-2xl leading-normal lg:leading-normal text-center';

export const AuthTitle = ({
  isModal = true,
  className,
  ...props
}: { isModal?: boolean } & React.HTMLAttributes<HTMLHeadingElement>) => (
  <h2
    className={cn(
      'font-semibold lg:text-3xl text-2xl  lg:leading-11.5 leading-9 text-black text-center',
      !isModal && 'lg:text-4xl text-left',
      className
    )}
    {...props}
  />
);
